import GB from 'country-flag-icons/react/3x2/GB';
import FI from 'country-flag-icons/react/3x2/FI';
import SE from 'country-flag-icons/react/3x2/SE';
import DE from 'country-flag-icons/react/3x2/DE';
import FR from 'country-flag-icons/react/3x2/FR';
import ES from 'country-flag-icons/react/3x2/ES';
import NL from 'country-flag-icons/react/3x2/NL';
import type { Locale } from '@/i18n/locales';
import { cn } from '@/lib/utils';

const FLAGS: Record<Locale, typeof FI> = {
  en: GB,
  fi: FI,
  sv: SE,
  de: DE,
  fr: FR,
  es: ES,
  nl: NL,
};

/**
 * Real SVG flag (from country-flag-icons), not an emoji. Set width via className
 * (e.g. "w-5"); the wrapper rounds the corners and adds a hairline so light flags
 * (FI, DE) stay visible on any background.
 */
export default function Flag({ code, className }: { code: Locale; className?: string }) {
  const Svg = FLAGS[code];
  return (
    <span
      className={cn(
        'inline-block overflow-hidden rounded-[3px] ring-1 ring-black/10 leading-none',
        className
      )}
    >
      <Svg className="block w-full h-auto" />
    </span>
  );
}
